import { NewsSkeleton } from '@fe-common-ui/LoadingSkeleton';
import { styled } from '@linaria/react';

const Container = styled.div<{ gap?: number }>`
  gap: ${({ gap }) => gap || 0}px;
  display: flex;
  flex-direction: column;
`;

const InterestedSkeletion = ({ limit = 10, gap = 16 }) => {
  return (
    <Container gap={gap}>
      {Array.from({ length: limit })
        .fill(0)
        .map((_, index) => (
          <NewsSkeleton key={`skelton-${index}`} height={107} />
        ))}
    </Container>
  );
};

export default InterestedSkeletion;
